import { render, staticRenderFns } from "./PageResult.vue?vue&type=template&id=e60fe7da&scoped=true&"
import script from "./PageResult.vue?vue&type=script&lang=js&"
export * from "./PageResult.vue?vue&type=script&lang=js&"
import style0 from "./PageResult.vue?vue&type=style&index=0&id=e60fe7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60fe7da",
  null
  
)

export default component.exports